// Builds the CreateBixAutoOfferUpsellInput from raw applicant + farmLocations[0] data.
// Returns null when any required field is missing — the upsell card hides itself in that
// case rather than sending an undeliverable request. See GitHub issue #27759.
//
// Exactly one of `branchOfferId` (offer page) or `branchPolicyId` (customer page) must
// be set; the BE uses whichever was passed as its redis dedupe key, mirroring how
// `assurityLifeCheckEligibility` accepts the same pair.

export function buildBixAutoUpsellInput({ branchOfferId, branchPolicyId, applicant, farmAddress, email, phone }) {
  if (!branchOfferId && !branchPolicyId) {
    return null;
  }
  if (!applicant?.firstName || !applicant?.lastName) {
    return null;
  }
  if (!farmAddress?.address || !farmAddress?.city || !farmAddress?.state || !farmAddress?.zip) {
    return null;
  }

  return {
    branchOfferId: branchOfferId || null,
    branchPolicyId: branchPolicyId || null,
    firstName: applicant.firstName,
    lastName: applicant.lastName,
    address: farmAddress.address,
    city: farmAddress.city,
    state: farmAddress.state,
    zip: farmAddress.zip,
    email: email || null,
    phone: phone || null
  };
}
